import { useCallback } from 'react'

import * as S from './styles'

const RangeSlider: React.FC<RangeSliderProps> = ({
  min,
  max,
  value,
  onChange,
  readOnly = false,
  minLabel,
  maxLabel,
  size = 'medium',
  isRangeValue = false
}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!readOnly) {
        onChange?.(Number(event.target.value))
      }
    },
    [onChange, readOnly]
  )

  if (isRangeValue) {
    const MIN_DISTANCE_THRESHOLD = 10
    const leftMax =
      max - min <= MIN_DISTANCE_THRESHOLD ? `calc(${max}% + 0.5rem)` : `${max}%`

    return (
      <S.RangeWrapper>
        <S.Label>0%</S.Label>
        <S.RangeTrack>
          <S.HighlightBar highlightStart={min} highlightWidth={max - min} />
          <S.HighlightLabel style={{ left: `${min}%` }}>
            {min}%
          </S.HighlightLabel>
          <S.HighlightLabel style={{ left: leftMax }}>{max}%</S.HighlightLabel>
        </S.RangeTrack>
        <S.Label>100%</S.Label>
      </S.RangeWrapper>
    )
  }

  return (
    <S.Container className="range-slider--container d-flex align-items-center gap-2">
      {minLabel && <span>{minLabel}</span>}
      <S.Slider
        className={`range-slider--slider ${readOnly ? 'read-only' : ''}`}
        data-size={size}
        type="range"
        min={min}
        max={max}
        onChange={handleChange}
        disabled={readOnly}
        readOnly={readOnly}
        {...(readOnly ? { value } : {})}
      />
      {maxLabel && <span>{maxLabel}</span>}
    </S.Container>
  )
}

export default RangeSlider
